function foldAsciiLower(s: string): string {
  return s
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
}

/**
 * Detect "show more" style utterances for pending patient disambiguation (aligned with server heuristics).
 */
export function transcriptIsShowMorePatients(text: string): boolean {
  const t = foldAsciiLower(text || '')
  if (!t) return false
  if (
    [
      'show more',
      'more',
      'more results',
      'next',
      'next page',
      'load more',
      'afficher plus',
      'affiche plus',
      'voir plus',
      'montre plus',
      'plus de resultats',
      'resultats suivants',
      'les resultats suivants',
      'afficher la suite',
      'affiche la suite',
      'voir la suite',
      'montre la suite',
    ].includes(t)
  ) {
    return true
  }
  if (/\b(show|display|see|view)\s+(more|additional|next)\b/.test(t)) return true
  if (/\b(more|next)\s+(patients|results|options|choices)\b/.test(t)) return true
  if (/\b(afficher|affiche|voir|montre)\s+(plus|la\s+suite|suite)\b/.test(t)) return true
  if (/\b(plus|suivant|suivante|suivants|suivantes)\s+(de\s+)?(patients|resultats|options|choix)\b/.test(t)) {
    return true
  }
  if (/\b(voir plus|montre plus|affiche plus|autres resultats|resultats suivants)\b/.test(t)) {
    return true
  }
  if (t.includes('suite') && t.includes('patient')) return true
  return false
}
